import React, { Component } from "react";
import "./stylesheets/headerback.css";
import constant from "../../../configs/constant";
import Auth from "../../../modules/Auth";
import { getBackNotificationList } from "../../../modules/serverCall";
import { Navbar, Nav, Container, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { AiFillHome, AiOutlineLogout } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import { CgNotes } from "react-icons/cg";

export default class HeaderBack extends Component {
  constructor(props) {
    super(props);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const display_name = readData.userdata.display_name;
    var currentPath = window.location.pathname;
    this.state = {
      scope: "Services",
      headerapp: "Approvals",
      display_name: display_name,
      currentPath: currentPath,
      showSplash: false,
      tantedList: [],
    };
  }

  componentDidMount() {
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const accesstokendata = localStorage.getItem("user_tenant");
    const readData = JSON.parse(accesstokendata);
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    var tantedList = readData;

    // navigator.mediaDevices.getUserMedia({audio:true, video:true})
    // .then(function(stream) {
    //   console.log('stream',stream);
    //   // myVideoStream = stream;
    //   // // display my local video to me
    //   // myVideo.srcObject = stream;
    // })
    // .catch(function(err) {
    //   console.log(err);
    // });
    this.setState({
      tantedList: tantedList,
    });

    if (readDataSelected === null) {
      this.setState({
        showClass: true,
      });
    }
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        this.setState({
          headerapp: "Validate",
        });
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        this.setState({
          headerapp: "Approvals",
        });
      }
    } else {
    }
    window.scrollTo(0, 0);
    // Check if the splash modal should be shown here
    const splashShowed = localStorage.getItem("splashShowed");
    if (!splashShowed || splashShowed === "false") {
      this.checkSplashScreen();
    }
  }

  checkSplashScreen = () => {
    const lastSplashDate = localStorage.getItem("last_splash_date");
    const today = new Date();
    if (!lastSplashDate) {
      localStorage.setItem("last_splash_date", today);
    }
    const lastSplashDateSaved = new Date(
      localStorage.getItem("last_splash_date")
    );

    if (today.getDate() - lastSplashDateSaved.getDate() > 2) {
      this.setState({ showSplash: false });
    } else {
      this.setState({ showSplash: true });
    }
  };

  handleOpenInNewWindow = () => {
    window.open("/release-note", "_blank");
  };

  handleInNewTab = (event) => {
    var url =
      "https://thejoengineering-my.sharepoint.com/:b:/g/personal/itcorp_thejo-engg_com/Eade7YbgjDhAhcHIgT2FPgYB3dbAZohmTEqgXqdwqrV8sQ?e=amL3Lo";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  handleCloseSplash = (event) => {
    this.setState({
      showSplash: false,
    });
    localStorage.setItem("splashShowed", "true");
  };

  handleChange = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        Auth.logout();
      }
    });
  };

  handleShowData = (event) => {
    const accesstokendata = localStorage.getItem("user_tenant");
    const readData = JSON.parse(accesstokendata);
    var tantedList = readData;
    this.setState({
      tantedList: tantedList,
      showClass: true,
      showSplash: false,
    });
  };

  handleClose = (event) => {
    this.setState({
      showClass: false,
    });
  };

  handleTenant = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    var selected_tenant = {
      ApplicationTenantID: event.ApplicationTenantID,
      Tenant: event.Tenant,
    };
    localStorage.setItem("selected_tenant", JSON.stringify(selected_tenant));
    // const fetchLogin = async () => {
    //   var sendData = {
    //     userId:cusId
    //   }
    //   var redirectData = "/job-view";
    //   var notificationData = await getBackNotificationList(sendData);
    //   if(notificationData.length > 0){
    //       redirectData = "/notification";
    //   }
    //   window.location.href = redirectData;
    //   this.setState({
    //     showClass :false,
    //   });
    // }
    // fetchLogin();
    window.location.reload();
  };

  render() {
    const logocompany = require("../../../assets/images/Thejo Splice logofive.png");
    const spliceLogo = require("../../../assets/images/SpliceLogo.png");
    const homeLogo = require("../../../assets/images/home2.png");
    const homeBlueLogo = require("../../../assets/images/homeblue.png");
    const logoutLogo = require("../../../assets/images/logout.png");
    const helpLogo = require("../../../assets/images/help.png");
    const switchLogo = require("../../../assets/images/2374111-200.png");
    var tantedList = this.state.tantedList;

    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    return (
      <header className="header-back container">
        <Navbar bg="light" className="back-nav">
          <Navbar.Brand href="#home">
            <NavLink className="nav-link text-end" to="/job-view">
              <img src={logocompany} alt="logo" className="logo-header-back" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="navData">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/job-view"
                title="Home"
              >
                <img
                  src={
                    this.state.currentPath === "/job-view"
                      ? homeBlueLogo
                      : homeLogo
                  }
                  alt="logo"
                  className="logo-header-home"
                />
              </NavLink>
              {selectedTenantData.Tenant === "Thisco" ? null : (
                <>
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "active-menu nav-link font_size"
                        : "nav-link nav-link-data font_size"
                    }
                    to="/incentive"
                  >
                    Incentive
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "active-menu nav-link font_size"
                        : "nav-link nav-link-data font_size"
                    }
                    to="/allowance"
                  >
                    Allowance
                  </NavLink>
                </>
              )}
              {selectedTenantData.Tenant === "Thisco" ? (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "active-menu nav-link font_size"
                      : "nav-link nav-link-data font_size"
                  }
                  to="/ot-hours"
                >
                  OT Hours
                </NavLink>
              ) : null}
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/validate"
              >
                Close Month
              </NavLink>
              {selectedTenantData.Tenant === "Thisco" ? null : (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "active-menu nav-link font_size"
                      : "nav-link nav-link-data font_size"
                  }
                  to="/service-report"
                >
                  Service Report
                </NavLink>
              )}
              {selectedTenantData.Tenant === "Thisco" ? null : (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "active-menu nav-link font_size"
                      : "nav-link nav-link-data font_size"
                  }
                  to="/sr-summary"
                >
                  SR Summary
                </NavLink>
              )}
              {/* <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/pending'>Pending</NavLink> */}
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/user"
              >
                User
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/customer"
              >
                Customer
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/notification"
              >
                Notification
              </NavLink>
              {/* {selectedTenantData.Tenant === "Thisco" ? (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "active-menu nav-link font_size"
                      : "nav-link nav-link-data font_size"
                  }
                  to="/change-password"
                >
                  Change Password
                </NavLink>
              ) : null} */}
              <NavItem
                className="nav-link cursorClass font_size"
                onClick={this.handleInNewTab}
              >
                <img src={helpLogo} alt="logo" className="logo-header-help" />
              </NavItem>
              {tantedList.length > 1 ? (
                <NavItem
                  className="nav-link cursorClass font_size"
                  onClick={this.handleShowData}
                >
                  <img
                    src={switchLogo}
                    alt="logo"
                    className="logo-header-help"
                  />
                </NavItem>
              ) : (
                ""
              )}
            </Nav>
            <Nav className="me-auto2">
              <div className="flexbox">
                <span className="diplay_name ml-auto">
                  {this.state.display_name}
                </span>
                <span className="header_name_data">
                  <b>
                    <img src={spliceLogo} alt="logo" className="icon-header" />
                  </b>
                </span>
                <span className="verClassother">{constant.appVersions}</span>
              </div>
              <span className="flexbox">
                <NavItem
                  className="nav-link cursorClass font_size marginReleaseNote"
                  // to="/release-note"
                  onClick={this.handleOpenInNewWindow}
                  title="Release Note"
                >
                  <CgNotes className="homeIconClass" size={20} color="black" />
                </NavItem>
                <NavItem
                  className="nav-link cursorClass font_size"
                  onClick={this.handleChange}
                  title="Logout"
                >
                  <img
                    src={logoutLogo}
                    alt="logo"
                    className="logo-header-logout"
                  />
                </NavItem>
              </span>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Modal
          show={this.state.showClass}
          backdrop="static"
          onHide={this.state.handleClose}
        >
          <Modal.Header>
            <Modal.Title>Select</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modelBody">
            {tantedList.length > 0
              ? tantedList.map((item, indexdata) => {
                  return (
                    <p
                      className="tenantClass"
                      onClick={(event) => this.handleTenant(item)}
                    >
                      {item.Tenant}
                    </p>
                  );
                })
              : ""}
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showSplash}
          backdrop="static"
          className=" d-flex align-items-center justify-content-center "
          onHide={() => this.setState({ showSplash: false })}
        >
          <Modal.Body className="modelBody modal-bg-img">
            <span onClick={this.handleCloseSplash} className="cross-btn">
              x
            </span>
            <div className="d-flex">
              <div>
                <img
                  src="https://d2o6woj9n5zgsq.cloudfront.net/images/blog/photos/EPAs+New+Tier+4+Final+Emission+Standards+Trigger+New+Construction+Technologies.jpg"
                  className="bgimage-modal"
                />
              </div>
              <div className="mt-2 p-4">
                <div>
                  {" "}
                  <img
                    src={logocompany}
                    alt="logo"
                    className="logo-header-back logo-size"
                  />
                </div>
                <h2 className="update-heading mt-2"> New Feature Update !! </h2>
                <div className="update-para mt-2">
                  Please refer to Release Note <CgNotes /> attached for details.
                </div>
                {/* <div className="update-para">is now online...</div> */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    );
  }
}
